module.exports = __webpack_public_path__ + "img/error-dark.67a6c92b.svg";